import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'retailers-filter_clear-click';
/**
 * Filter clear event
1. Name
2. Location
3. Section name etc
*/
export function trackRetailersFilterClearClick(customParameterToken, customParameterToken2, customParameterToken3) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: {
            customParameterToken,
            customParameterToken2,
            customParameterToken3,
        },
    });
}
